import * as operateList from '../services/operateList';

export default {
  namespace: 'operateList',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getOperateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(operateList.getOperateList, values);
      yield put({
        type: 'save',
        payload: {
          operateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //暂停
    *activityGroupPause({ payload: { values }, callback }, { call }) {
      const response = yield call(operateList.activityGroupPause, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //终止
    *activityGroupTerminate({ payload: { values }, callback }, { call }) {
      const response = yield call(operateList.activityGroupTerminate, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //重启
    *activityGroupRestart({ payload: { values }, callback }, { call }) {
      const response = yield call(operateList.activityGroupRestart, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //审核
    *activityGroupApprove({ payload: { values }, callback }, { call }) {
      const response = yield call(operateList.activityGroupApprove, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
